<div>
    <div class="col-lg-6 mx-auto mt-2 colorborder form-section">
        <router-outlet></router-outlet>
    </div>
</div>
